// Exact matches first, semantic search as the fallback.
//
// Shopify's semantic search has no relevance cutoff. A plain "subeng" returns
// 168 products, but only 51 contain the word; the other 117 are the nearest
// earrings, rings and pendants in the catalog, down to ones with nothing in
// common with the query. Quoting every word ("subeng") switches Shopify to
// exact matching and returns just the 51.
//
// Exact matching alone would break typos and Indonesian words (kalung, anting
// and subng all have 0 exact hits), so the quoted query is only used when it
// finds enough products. Otherwise the query goes out as typed and semantic
// search handles it, as before.
//
// The check is one small request (templates/search.count.liquid) made when the
// search is submitted. If it fails or is slow, the search goes out as typed.
(function() {
  if (!window.fetch || !window.URLSearchParams || !window.FormData || !window.Promise) {
    return;
  }

  // Fewer exact hits than this and the semantic results are more useful than
  // a nearly empty page
  var MIN_EXACT_RESULTS = 8;
  var PROBE_TIMEOUT = 2500;
  // Longer queries are sentences, not product words; leave them to semantic
  var MAX_WORDS = 6;

  var busy = false;

  function isSearchForm(form) {
    return !!form &&
      form.getAttribute &&
      form.getAttribute('role') === 'search' &&
      /\/search\/?$/.test(form.getAttribute('action') || '');
  }

  // Quote each word, or return null when the text should not be touched
  function exactQuery(raw) {
    var text = (raw || '').trim();

    // Empty, or already written with search syntax: the visitor knows what
    // they are doing. A backslash is left alone too, so it can never escape
    // the closing quote of a quoted word.
    if (!text || /["*:()\\]|(^|\s)-|\s(AND|OR|NOT)\s/.test(text)) {
      return null;
    }

    var words = text.split(/\s+/);
    if (words.length > MAX_WORDS) {
      return null;
    }

    return words.map(function(word) {
      return '"' + word + '"';
    }).join(' ');
  }

  function countExact(form, exact) {
    var params = new URLSearchParams(new FormData(form));
    params.set('q', exact);
    params.set('view', 'count');

    var request = fetch(form.getAttribute('action') + '?' + params.toString(), {
      credentials: 'same-origin'
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Exact match count failed: ' + response.status);
        }
        return response.text();
      })
      .then(function(text) {
        var count = parseInt(text.trim(), 10);
        if (isNaN(count)) {
          throw new Error('Exact match count was not a number');
        }
        return count;
      });

    var timeout = new Promise(function(resolve, reject) {
      setTimeout(function() {
        reject(new Error('Exact match count timed out'));
      }, PROBE_TIMEOUT);
    });

    return Promise.race([request, timeout]);
  }

  // HTMLFormElement.prototype.submit does not fire a submit event, so this
  // cannot loop back into the listener below
  function submitAsTyped(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function submitForm(form) {
    if (!form) {
      return;
    }

    var input = form.querySelector('input[name="q"]');
    var exact = input ? exactQuery(input.value) : null;

    if (!exact) {
      submitAsTyped(form);
      return;
    }

    if (busy) {
      return;
    }
    busy = true;
    form.setAttribute('aria-busy', 'true');

    countExact(form, exact)
      .then(function(count) {
        if (count < MIN_EXACT_RESULTS) {
          return false;
        }
        // Navigate instead of editing the form, so the field keeps what was
        // typed (including after the back button)
        var params = new URLSearchParams(new FormData(form));
        params.set('q', exact);
        window.location.assign(form.getAttribute('action') + '?' + params.toString());
        return true;
      })
      .catch(function() {
        return false;
      })
      .then(function(navigated) {
        busy = false;
        form.removeAttribute('aria-busy');
        if (!navigated) {
          submitAsTyped(form);
        }
      });
  }

  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    if (!isSearchForm(form)) {
      return;
    }

    var input = form.querySelector('input[name="q"]');
    if (!input || !exactQuery(input.value)) {
      return;
    }

    evt.preventDefault();
    submitForm(form);
  });

  // The live search dropdown's "view all" button submits through here
  window.tulolaSearch = { submit: submitForm };
})();
